module.exports = __webpack_public_path__ + "img/63.2bf79f5c.jpg";